import { render } from "./frankaResearch3.vue?vue&type=template&id=50531cd8&scoped=true"
import script from "./frankaResearch3.vue?vue&type=script&lang=js"
export * from "./frankaResearch3.vue?vue&type=script&lang=js"

import "./frankaResearch3.vue?vue&type=style&index=0&id=50531cd8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50531cd8"]])

export default __exports__